import { css } from 'styled-components';

const textStyle = css`
    color: #17394D;
    font: 400 15px Helvetica, serif;
    font-family: Helvetica, serif;
    font-size: 15px;
    font-weight: 400;
`;

export default textStyle;
